<template>
  <div>
    <DetailIndex :inspectionCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-fabric-inspection-report',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
